import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "@/lib/adminApi";
import { ArrowRight, Mail, Loader2 } from "lucide-react";
import { BRAND } from "@/lib/config";

export default function AdminForgotPassword() {
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await requestPasswordReset();
      setSent(true);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) {
        setError(
          "Muitas tentativas. Aguarde uma hora antes de tentar novamente."
        );
      } else {
        setError("Erro ao enviar o pedido. Tente novamente em instantes.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-forgot-page"
      className="min-h-screen bg-[#f4f1ea] text-[#1e2a5a] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#1e2a5a] text-[#1e2a5a] font-display italic">
            L
          </span>
          <span className="font-display text-lg">{BRAND.name}</span>
        </div>

        <p className="overline">Acesso restrito</p>
        <h1 className="font-display mt-4 text-4xl sm:text-5xl tracking-tight leading-[1.05]">
          Esqueceu a senha?
        </h1>
        <p className="mt-6 text-base text-[#5c5c5c] leading-relaxed">
          Vamos enviar um link de redefinição para o e-mail registrado do administrador.
          O link expira em <strong>30 minutos</strong>.
        </p>

        {sent ? (
          <div
            data-testid="admin-forgot-success"
            className="mt-10 bg-white border border-[#1e7a3e]/30 rounded-xl p-6"
          >
            <p className="font-display text-xl text-[#1e7a3e]">
              Link enviado!
            </p>
            <p className="mt-3 text-sm text-[#3a3a3a] leading-relaxed">
              Confira a caixa de entrada do e-mail do administrador (e a pasta de spam).
              Use o link recebido para definir uma nova senha.
            </p>
            <Link
              to="/admin"
              className="mt-6 inline-flex items-center gap-2 text-sm link-underline text-[#1e2a5a]"
            >
              ← Voltar para o login
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-10 space-y-5">
            {error && (
              <p
                data-testid="admin-forgot-error"
                className="text-sm text-[#d9381e]"
              >
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="admin-forgot-submit"
              disabled={submitting}
              className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#1e2a5a] px-6 py-3.5 text-sm font-medium text-[#f4f1ea] transition-colors hover:bg-[#d9381e] disabled:opacity-60"
            >
              {submitting ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" /> Enviando…
                </>
              ) : (
                <>
                  <Mail className="h-4 w-4" /> Enviar link de redefinição
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </>
              )}
            </button>

            <div className="pt-2">
              <Link
                to="/admin"
                className="text-sm link-underline text-[#5c5c5c]"
              >
                ← Voltar para o login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
